// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_N2D","content":"styles_content__15JaQ"};